// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-label__year[data-v-15462580] {\n  font-size: 0.875rem;\n}\n.date-label__date[data-v-15462580] {\n  font-size: 1.625rem;\n  font-weight: bold;\n  text-transform: capitalize;\n}\n.date-label-divider[data-v-15462580] {\n  height: 3rem;\n  width: 2px;\n  background-color: #C1C1C1;\n}", ""]);
// Exports
module.exports = exports;
